import SectionHeading from '../HomePage/SectionHeading'
import CaseStudyCard from './CaseStudyCard'

const caseStudies = [
    {
        title: 'Turning Leads into Deals',
        client: 'Client: John D., Real Estate Investor',
        description:
            'John was struggling to generate quality leads in a competitive market. After partnering with <a href="/">Open Letter Marketing</a>, we designed a targeted <strong>direct mail marketing campaign for real estate</strong> that focused on distressed property owners. Within three months, John saw a 40% increase in lead generation and closed several profitable deals. Our detailed analytics helped John refine his approach, making his marketing efforts more efficient and effective.',
        image: '/assets/reviews/case-studies/1.png',
        imageAlt:
            'A smiling Black man in a suit is standing behind a miniature cityscape model, holding a laptop and giving a thumbs up sign next to a large window overlooking a city.',
        imageTitle: 'Real estate developer with a model city.',
    },
    {
        title: 'Streamlining Marketing for Growth',
        client: 'Lisa M., Realtor',
        description:
            'Lisa wanted to expand her reach but found it challenging to manage her marketing efforts while handling her growing client base. Open Letter Marketing created a customized <a href="https://openlettermarketing.com/products">direct mail campaign</a> that automated her outreach process. The results were immediate: Lisa reported a 35% increase in client inquiries and was able to spend more time focusing on closing deals. The campaign’s success allowed her to hire an assistant and further scale her business.',
        image: '/assets/reviews/case-studies/2.png',
        imageAlt:
            'A female agent with glasses is pointing to a laptop screen while meeting with a smiling couple across a table to discuss documents.',
        imageTitle: 'Real estate agent meeting with a couple.',
    },
    {
        title: 'Maximizing ROI with Targeted Campaigns',
        client: 'Robert K., Property Developer',
        description:
            'Robert’s goal was to attract investors for a new development project. We crafted a direct mail strategy that targeted high-net-worth individuals and included personalized invitations to an exclusive preview event. The response was overwhelming, with a 50% attendance rate and multiple investment commitments. Robert praised the professionalism and effectiveness of the campaign, which significantly exceeded his expectations.',
        image: '/assets/reviews/case-studies/3.png',
        imageAlt:
            'Two smiling business professionals, a woman in a white hard hat and a man in a suit, are holding blueprints outdoors in front of a modern glass building. The woman is pointing into the distance.',
        imageTitle: 'Architects or engineers reviewing blueprints on-site.',
    },
]

function CaseStudies() {
    return (
        <div
            data-id="case-studies"
            className="m-auto max-w-full md:w-[1200px] md:px-0 px-4 text-center space-y-10 md:space-y-20">
            <SectionHeading>Case Studies</SectionHeading>
            <div className="space-y-14">
                {caseStudies &&
                    caseStudies.map((study, i) => {
                        // need to add left attribute to the first card
                        return (
                            <CaseStudyCard
                                key={i}
                                study={study}
                                alignment={i % 2 === 0 && 'left'}
                            />
                        )
                    })}
            </div>
        </div>
    )
}

export default CaseStudies
